// Function to toggle the cart drawer (open/close)
function toggleCart() {
    var kaktusApp = document.getElementById("kaktusc-app");

    if (kaktusApp) {
        // Check the current display state of the cart drawer
        if (kaktusApp.style.display === "block") {
            kaktusApp.style.display = "none";  // Close the cart drawer
            console.log("Cart drawer (Kaktus app) is now hidden.");
        } else {
            kaktusApp.style.display = "block"; // Open the cart drawer
            console.log("Cart drawer (Kaktus app) is now visible!");
        }
    } else {
        console.error("Kaktus app element not found!");
    }
}

// Trigger the toggleCart function when the button is clicked
document.getElementById("showCartButton").addEventListener("click", function() {
    console.log("Cart button clicked, toggling cart drawer.");
    toggleCart();
});

// Show the cart drawer automatically when the page loads
window.addEventListener('load', function() {
    console.log("Page loaded, showing the cart drawer.");
    toggleCart(); // Open the cart drawer when the page loads
});
